import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ru: {
                translation: {
                    delivery: 'Доставка',
                    payment: 'Оплата',
                    bonuses: 'Бонусы',
                    promo: 'Акции',
                    search: 'Поиск…',
                    messages: 'Сообщения',
                    notifications: 'Уведомления',
                    profile: 'Профиль',
                    my_account: 'Мой аккаунт',
                    cart: 'Корзина',
                    cart_empty: 'Корзина пуста',
                    my_cart:"Ваша корзина",
                    delete: 'Удалить',
                    favorites: 'Избранное',
                    favorites_empty: 'Список избранного пуст',
                    comparison: 'Сравнение',
                    comparison_empty: 'Список сравнения пуст',
                    price_unit: 'лей',
                    addToCart: 'В корзину',
                    inCart: 'В корзине',
                    cashback: 'Кэшбэк',
                    newProducts: "Новинки",
                    discountedProducts: "Снизилась цена",
                    topProducts: "Топ продаж",
                    popularCategories: 'Популярные категории',
                    profile_login: "Войти в профиль",
                    catalog: {
                        title: "Каталог товаров",
                    },
                    mobile_catalog:"Каталог",
                    about: "О нас",
                    contacts:"Контакты",
                    jobs: "Вакансии",
                    suppliers: "Поставщикам",
                    privacy_policy: "Политика конфиденциальности",

                    exchange: "Обмен и возврат товара",
                    consumer_protection: "Защита прав потребителей",
                    public_offer: "Публичная оферта",

                    buyer: "Покупателю",
                    useful_information:"Полезная информация",
                    download_app:"Загрузите наше приложение",
                    socials:"Мы в социальных сетях",
                    accept_payment:"Принимаем к оплате",
                    footer_copyright:"Интернет-магазин EasyShop | Превратит покупку в удовольствие",
                    email:"Ваш E-mail",
                    password:"Пароль",
                    entrance:"Вход",
                    call:"Позвонить",
                    forgot_password: "Забыли пароль?",
                    registration:"Регистрация",
                    entrance_socials:"Вход через соц. сети",
                    in_development: "В РАЗРАБОТКЕ",
                    placeholder_text: "Страница ещё в разработке, возвращайтесь позже 🚧",
                    empty_cart:"Корзина пуста",
                    empty_cart_placeholder:"Здесь появятся товары, которые вы добавили в корзину.",
                    add_to_cart:"Добавить товары",
                    fun_placeholder:"Мы работаем над этой страницей. Она скоро оживёт!",
                    fun_placeholder_title:"Страница в разработке",
                    bonuses_placeholder:"Бонусы скоро будут активны!",
                    delivery_placeholder:"Страница доставки скоро будет доступна!",
                    payment_placeholder:"Оплата будет доступна совсем скоро!",
                    login_registration: "Вход | Регистрация",
                    location:"мун. Кишинэу",
                    deselect:"Снять выделение",
                    select_all:"Выбрать всё",
                    price: "Стоимость товаров",
                    proceed_to_checkout: "Перейти к оформлению",
                    buy:"Купить в 1 клик",
                    working_hours: "Пн–Пт: 9:00–18:00\nСб–Вс: выходной",
                    delete_selected: "удалить выбранное",






                    subcategory_A1:"Подкатегория А.1",
                    subcategory_A2:"Подкатегория А.2",
                    subcategory_A3:"Подкатегория А.3",
                    subcategory_A4:"Подкатегория А.4",
                    subcategory_A5:"Подкатегория А.5",
                    subcategory_A6:"Подкатегория А.6",
                    subcategory_A7:"Подкатегория А.7",
                    subcategory_A8:"Подкатегория А.8",

                    subcategory_B1:"Подкатегория B.1",
                    subcategory_B2:"Подкатегория B.2",
                    subcategory_B3:"Подкатегория B.3",
                    subcategory_B4:"Подкатегория B.4",
                    subcategory_B5:"Подкатегория B.5",
                    subcategory_B6:"Подкатегория B.6",
                    subcategory_B7:"Подкатегория B.7",

                    subcategory_C1:"Подкатегория C.1",
                    subcategory_C2:"Подкатегория C.2",
                    subcategory_C3:"Подкатегория C.3",
                    subcategory_C4:"Подкатегория C.4",
                    subcategory_C5:"Подкатегория C.5",
                    subcategory_C6:"Подкатегория C.6",
                    subcategory_C7:"Подкатегория C.7",

                    subcategory_D1:"Подкатегория D.1",
                    subcategory_D2:"Подкатегория D.2",
                    subcategory_D3:"Подкатегория D.3",
                    subcategory_D4:"Подкатегория D.4",
                    subcategory_D5:"Подкатегория D.5",
                    subcategory_D6:"Подкатегория D.6",
                    subcategory_D7:"Подкатегория D.7",

                    subcategory_E1:"Подкатегория E.1",
                    subcategory_E2:"Подкатегория E.2",
                    subcategory_E3:"Подкатегория E.3",
                    subcategory_E4:"Подкатегория E.4",
                    subcategory_E5:"Подкатегория E.5",

                    subcategory_F1:"Подкатегория F.1",
                    subcategory_F2:"Подкатегория F.2",
                    subcategory_F3:"Подкатегория F.3",

                    sectionA:"Раздел А",
                    sectionB:"Раздел B",
                    sectionC:"Раздел C",
                    sectionD:"Раздел D",
                    sectionE:"Раздел E",
                    sectionF:"Раздел F",

                }
            },
            ro: {
                translation: {
                    delivery: 'Livrare',
                    payment: 'Plată',
                    bonuses: 'Bonusuri',
                    promo: 'Promoții',
                    search: 'Căutare…',
                    messages: 'Mesaje',
                    notifications: 'Notificări',
                    profile: 'Profil',
                    my_account: 'Contul meu',
                    cart: 'Coșul',
                    cart_empty: 'Coșul este gol',
                    my_cart:"Coșul meu",
                    delete: 'Șterge',
                    favorites: 'Favorite',
                    favorites_empty: 'Lista de favorite este goală',
                    comparison: 'Comparare',
                    comparison_empty: 'Lista de comparare este goală',
                    price_unit: 'lei',
                    addToCart: 'În coș',
                    inCart: 'Adăugat',
                    cashback: 'Cashback',
                    newProducts: "Noutăți",
                    discountedProducts: "Reduceri",
                    topProducts: "Cele mai vândute",

                    popularCategories: 'Categorii populare',
                    profile_login: "Autentificare în profil",
                    catalog: {
                        title: "Catalog de produse",
                    },
                    mobile_catalog:"Catalog",

                    about: "Despre noi",
                    contacts:"Contacte",
                    jobs: "Locuri vacante",
                    suppliers: "Pentru furnizori",
                    privacy_policy: "Politica de confidențialitate",

                    exchange: "Schimb și returnare de bunuri",
                    consumer_protection: "Protecția consumatorului",
                    public_offer: "Oferta publica",
                    buyer: "Către cumpărător",
                    useful_information:"Informații utile",
                    download_app:"Descărcați aplicația noastră",
                    socials:"Noi pe rețelele sociale",
                    accept_payment:"Acceptăm plăți",
                    footer_copyright:"Magazinul online EasyShop | Transformă cumpărăturile într-o plăcere",
                    email:"E-mailul dvs",
                    password:"Parolă",
                    entrance:"Intrare",
                    call:"Apel",
                    forgot_password: "Ați uitat parola?",
                    registration:"Înregistrare",
                    entrance_socials:"Conectați-vă prin rețelele sociale",
                    in_development: "ÎN DEZVOLTARE",
                    placeholder_text: "Această pagină este încă în construcție, vă rugăm să reveniți mai târziu. 🚧",
                    empty_cart:"Coșul este gol",
                    empty_cart_placeholder:"Produsele pe care le-ați adăugat în coș vor apărea aici.",
                    add_to_cart:"Adăugați produse",
                    fun_placeholder:"Lucrăm la această pagină. Va fi disponibilă în curând!",
                    fun_placeholder_title:"Pagina în construcție",
                    bonuses_placeholder:"Bonusurile vor fi active în curând!",
                    delivery_placeholder:"Pagina de livrare va fi disponibilă în curând!",
                    payment_placeholder:"Plata va fi disponibilă foarte curând!",
                    location:"mun. Chișinău",
                    price: "Costul mărfurilor",
                    proceed_to_checkout: "Finalizează cumpărăturile",
                    buy:"Cumpără cu 1 clic",
                    working_hours: "L–V: 9:00–18:00\nS–D: zi liberă",
                    delete_selected: "ștergeți selectat",





                    subcategory_A1:"Subcategorie A.1",
                    subcategory_A2:"Subcategorie A.2",
                    subcategory_A3:"Subcategorie A.3",
                    subcategory_A4:"Subcategorie A.4",
                    subcategory_A5:"Subcategorie A.5",
                    subcategory_A6:"Subcategorie A.6",
                    subcategory_A7:"Subcategorie A.7",
                    subcategory_A8:"Subcategorie A.8",

                    subcategory_B1:"Subcategorie A.1",
                    subcategory_B2:"Subcategorie A.2",
                    subcategory_B3:"Subcategorie A.3",
                    subcategory_B4:"Subcategorie A.4",
                    subcategory_B5:"Subcategorie A.5",
                    subcategory_B6:"Subcategorie A.6",
                    subcategory_B7:"Subcategorie A.7",


                    subcategory_C1:"Subcategorie C.1",
                    subcategory_C2:"Subcategorie C.2",
                    subcategory_C3:"Subcategorie C.3",
                    subcategory_C4:"Subcategorie C.4",
                    subcategory_C5:"Subcategorie C.5",
                    subcategory_C6:"Subcategorie C.6",
                    subcategory_C7:"Subcategorie C.7",

                    subcategory_D1:"Subcategorie D.1",
                    subcategory_D2:"Subcategorie D.2",
                    subcategory_D3:"Subcategorie D.3",
                    subcategory_D4:"Subcategorie D.4",
                    subcategory_D5:"Subcategorie D.5",
                    subcategory_D6:"Subcategorie D.6",
                    subcategory_D7:"Subcategorie D.7",

                    subcategory_E1:"Subcategorie E.1",
                    subcategory_E2:"Subcategorie E.2",
                    subcategory_E3:"Subcategorie E.3",
                    subcategory_E4:"Subcategorie E.4",
                    subcategory_E5:"Subcategorie E.5",

                    subcategory_F1:"Subcategorie F.1",
                    subcategory_F2:"Subcategorie F.2",
                    subcategory_F3:"Subcategorie F.3",

                    sectionA:"Secțiune А",
                    sectionB:"Secțiune B",
                    sectionC:"Secțiune C",
                    sectionD:"Secțiune D",
                    sectionE:"Secțiune E",
                    sectionF:"Secțiune F",
                    login_registration: "Autentificare | Înregistrare",
                    deselect:"Deselectați",
                    select_all:"Selectați toate",

                }
            }

        },
        lng: 'ru',
        fallbackLng: 'ru',
        interpolation: {escapeValue: false},
        keySeparator: '.',

    });

export default i18n;
